import React, { useEffect, useState, useContext, useCallback } from 'react';

import LoginContext from '../../../../store/login-context';

import Ajax from '../../../../Handler/Ajax';
import classes from './SMSOTP.module.scss';
import eye from '../../../../assets/icons/outline_eye_bright.svg';
import eyeOff from '../../../../assets/icons/outline_eye_bright-off.svg';
import timer from '../../../../assets/icons/timer.svg';
import SubmitBtn from '../../../Form/submit-button/submit-button.component';
import Toast from '../../../Form/Toast';
import GovSpinner from '../../../Form/GovSpinner';
import alert from '../../../../assets/icons/alert-circle-red.svg';
import MailOtp from '../MailOTP/mailOtp';
import arrowRightBlue from '../../../../assets/icons/arrow-right-blue.svg';
import BackLink from '../../../General/Static/BackLink/BackLink';
import { useWebOtp } from '../../../General/Static/WebOtp/useWebOtp';

declare function Translate(key: string): string;
declare var _loginType: any;
declare var _loginTypeSMSOTPSmartphoneEnrollment: any;
declare var _loginMethodSmsOtpUrl: any;

const SMSOTP = props => {
  
  const ctx = useContext(LoginContext);
  
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [controlType,setControlType] = useState('password');
  const [serverMessage,setServerMessage] = useState('');  
  const [otpDirty,setOtpDirty] = useState(false);
  const [showMailOtp,setShowMailOtp] = useState(false);
  const [maskMobile,setMaskMobile] = useState(props.maskOtpDest);
       
  useEffect(() => {    
    if(ctx.showSideNote){
      ctx.displaySideNote(false);
    }

    if(props.maskOtpDest.startsWith("UB")){
      var maskArr = props.maskOtpDest.split(':');
      setMaskMobile(maskArr[1]);
    }

    // update StepIndicator in ApplicationEnrollment
    if(_loginType === _loginTypeSMSOTPSmartphoneEnrollment){
      ctx.setEnrollmentSmsOtp();
    }
        
  },[]);

  // auto otp - start
  const handleWebOtp = useCallback((code: string) => {
    setOtp(code);
    setOtpDirty(true);
  },[]);
  
  useWebOtp({ onOtp: handleWebOtp });
  // auto otp - end
     
  const SecondStageLogin = () => {    
    setServerMessage('');

    if(ctx.devMode){
      let neededInfo = [  
        'email',
        'mobile',     
        'password',     
      ];
     
      props.Success(neededInfo);
      return;
    }

    if (otp.length !== 0) {      
      setLoading(true);
      
      Ajax.SecondLoginSMS(otp)
        .then((data: any) => {                              
          Ajax.onPKILoginEnd()
            .then((data: any) => {
              if(data.neededInfo[0].trim().length === 0 && data.currentState === "updateDetailsDone"){
                if(_loginType !== _loginTypeSMSOTPSmartphoneEnrollment){
                  Ajax.onPKILoginEndPK()
                    .then((data: any) => {
                      setLoading(false);
                      props.Success(data.neededInfo);
                    })
                    .catch((error) => {
                      setLoading(false);
                      setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));                    
                    }); 
                }
                else{
                  setLoading(false);
                  props.Success(data.neededInfo);
                }
              }
              else{
                props.Success(data.neededInfo);
              }               
            })
            .catch((error) => {
              setLoading(false);
              setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));                    
            });
        })
        .catch((error) => {
          setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));
          setLoading(false);                              
        });      
    }
  };

  const handleOtp = (e: React.ChangeEvent<HTMLInputElement>) => {
    const regex = /^[0-9]{0,6}$/;
    if (regex.test(e.target.value.toString()))
      setOtp(e.target.value);      
  };
  
  const isOtpValid = () => {
    return /\d{6}/.test(otp);
  };

  const onOtpBlur = () => {
    if(otp.length>0 && !otpDirty){
      setOtpDirty(true);
    }
  };
  const otpValidationMessage = () => {
    return otp.length === 0
      ? Translate('N_General_Error_Mandatory_Field')
      : Translate('N_General_Error_PIN_too short');
  };

  const handleEnter = (event) => {    
    if (event.charCode === 13) {      
      if(isOtpValid()){
        SecondStageLogin();
      }      
    }
  };
  
  const onSubmitForm = (event) => {
    event.preventDefault();
  }

  const getOtpToMailHandler = () => {

    if(!ctx.devMode){
      Ajax.SendOtpToMail()
        .then((data: any) => {                                        
          setShowMailOtp(true);
        })
        .catch((error) => {
          setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));
          setLoading(false);                             
        });  
    } 
    else{
      setShowMailOtp(true);
    }            
  }

  const onMailOtpCompleted = (neededInfo) => {
    props.Success(neededInfo);
  };

  const onBackHandler = () => {        

    if (!ctx.devMode) {
      setLoading(true); 
      Ajax.ResetUserStatus()
      .then(() => {           
        setLoading(false);        
        window.location = _loginMethodSmsOtpUrl;
      })
      .catch(() => {   
        setLoading(false); 
        setServerMessage(Translate('N_General_Error_SYSTEM_ERROR'));           
      });
    }
    else{      
       window.location = _loginMethodSmsOtpUrl;
    }     

    // if (!ctx.devMode) {
    //   setLoading(true); 
    //   Ajax.ResetUserStatus()
    //   .then(() => {           
    //     setLoading(false);        
    //     ctx.displaySideNote(true);  
    //     props.setStage(1);  
    //   })
    //   .catch(() => {   
    //     setLoading(false); 
    //     setServerMessage(Translate('N_General_Error_SYSTEM_ERROR'));           
    //   });
    // }
    // else{      
    //   props.setStage(1); 
    // }     
  };


  return (
        
    <React.Fragment>
      
      {showMailOtp === false && (
        <>
          <GovSpinner show={loading} />
          <div className={classes.sms_otp_wrapper}>
          <form className='normal-form' onSubmit={onSubmitForm} >
            
            { _loginType !== _loginTypeSMSOTPSmartphoneEnrollment &&
              <BackLink back={onBackHandler} loginType="" translate={Translate('N_Login_application_pop_up_3')}/>
            }  
            <div className= 'otp_heading' >
              <div className= 'title-large' >{Translate('N_General_SignUp_confirm_mobile_info_1')}</div>
              <div className={classes.description}>
                <span className='text-space'>
                  {Translate('N_Login_password_otp_title')}                  
                </span>                               
                <span className={classes.mask_otp}>{maskMobile}</span>
              </div>          
            </div>
            <div className= 'mainFormZone mt-4'>            
              <label htmlFor='smsOtp' className='my-1 d-flex align-items-center justify-content-between'>
                  <div>
                    {Translate('N_Login_reset_password_stage_2')}                                         
                  </div>
                  <div 
                    className='mx-2 d-flex align-items-center'
                    onClick={() =>
                      setControlType(
                        controlType === 'password'
                          ? 'text'
                          : 'password'
                      )
                    }
                  >
                    <img
                      src={controlType === 'password' ? eye : eyeOff}
                      width='22px'
                      height='18px'
                      
                      role='button'
                      tabIndex={0}
                      className={
                        otp
                          ? 'mx-1 password-view-show'
                          : 'mx-1 password-view-hide'
                      }
                      
                    />
                    <span 
                      className={
                        otp
                          ? 'password-view-show'
                          : 'password-view-hide'
                      }
                    >
                      {controlType === 'password' 
                        ? Translate('N_Login_Bio_ID_OTP_Show_OTP')
                        : Translate('N_Login_Bio_ID_OTP_Hide_OTP')
                      }
                    </span>                      
                  </div>
              </label>
              <input                                                  
                autoFocus   
                aria-describedby= {`${Translate('N_General_SignUp_confirm_mobile_info_1')} ${maskMobile} ${Translate('N_General_SignUp_confirm_mail_info_2')}`} 
                id='smsOtp' 
                autoComplete="one-time-code"               
                aria-required="true"
                type= 'tel' 
                value={otp}
                onChange={handleOtp}
                onKeyPress={handleEnter}
                onBlur={() => setTimeout(onOtpBlur, 500)}
                placeholder="_ _ _ _ _ _"
                className={
                  `
                    form-control gov-black                                           
                    ${!isOtpValid() && otpDirty ? ' error-control' : ''} 
                    ${controlType === 'password' ? classes.password_mask : ''}
                  `                    
                }
              />                
                 
              {otpDirty && !isOtpValid() && (
                <div className='d-flex align-items-center'>
                  <img src={alert}  className='error-alert' />
                  &nbsp;
                  <span className='small error'>
                    {otpValidationMessage()}
                  </span>
                </div>
              )}

              <div className='d-flex align-items-center mt-1'>
                <img src={timer}  width='16px' height='19px' />
                &nbsp;
                <span className={classes.note}>
                  {Translate('N_General_otp_time_limit_1')}
                </span>
              </div>

              {props.maskedEmail !== "" && !otpDirty && 
              <>               
                  <div id='getOtpToMail' className={classes.mailOtpDesc} >
                    <div>                    
                      <span>{Translate('N_Login_reset_password_no_otp')}</span>
                      <span onClick={getOtpToMailHandler} onKeyPress={getOtpToMailHandler} tabIndex={0} className={classes.no_code_link}>{Translate('N_Login_OTP_by_email') + ' ' + props.maskedEmail}</span>&nbsp;
                      
                    </div>                    
                  </div>               
              </>
              }

              {(props.maskedEmail === "" || otpDirty) && <div style={{'height':'32px'}}></div> }

              {serverMessage.length > 0 && (
                <Toast message={serverMessage} />
              )}

              <SubmitBtn
                title={Translate('N_Login_password_login_button')}
                id="loginOtpSubmit"
                action={SecondStageLogin}
                showIcon={true}
                disabled={!isOtpValid()}
              />  

              <div className={classes.heightLarger730}></div>                                                      
            </div>
          </form>
          </div>
        </>
      )}

      {showMailOtp === true && 
        <MailOtp                            
          maskMailDest={props.maskedEmail}
          Success={onMailOtpCompleted}           
        />
      }


    </React.Fragment>
    
  );

}
export default SMSOTP;


